import { apiClient } from './api.js';

class AccountingService {
  // ==================== Accounts ====================

  // Get all accounts
  async getAllAccounts() {
    try {
      return await apiClient.get('/accounting/accounts');
    } catch (error) {
      console.error('Error getting all accounts:', error);
      throw error;
    }
  }

  // Get account by ID
  async getAccountById(accountId) {
    try {
      return await apiClient.get(`/accounting/accounts/${accountId}`);
    } catch (error) {
      console.error(`Error getting account ${accountId}:`, error);
      throw error;
    }
  }

  // Create a new account
  async createAccount(account) {
    try {
      return await apiClient.post('/accounting/accounts', account);
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  }

  // Update an existing account
  async updateAccount(accountId, account) {
    try {
      return await apiClient.put(`/accounting/accounts/${accountId}`, account);
    } catch (error) {
      console.error(`Error updating account ${accountId}:`, error);
      throw error;
    }
  }

  // Delete an account
  async deleteAccount(accountId) {
    try {
      return await apiClient.delete(`/accounting/accounts/${accountId}`);
    } catch (error) {
      console.error(`Error deleting account ${accountId}:`, error);
      throw error;
    }
  }

  // Seed default accounts
  async seedDefaultAccounts() {
    try {
      return await apiClient.post('/accounting/seed-defaults');
    } catch (error) {
      console.error('Error seeding default accounts:', error);
      throw error;
    }
  }

  // ==================== Journal Entries ====================

  // Get all journal entries
  async getAllJournalEntries() {
    try {
      return await apiClient.get('/accounting/journal-entries');
    } catch (error) {
      console.error('Error getting all journal entries:', error);
      throw error;
    }
  }

  // Get journal entry by ID
  async getJournalEntryById(entryId) {
    try {
      return await apiClient.get(`/accounting/journal-entries/${entryId}`);
    } catch (error) {
      console.error(`Error getting journal entry ${entryId}:`, error);
      throw error;
    }
  }

  // Create a new journal entry
  async createJournalEntry(journalEntry) {
    try {
      return await apiClient.post('/accounting/journal-entries', journalEntry);
    } catch (error) {
      console.error('Error creating journal entry:', error);
      throw error;
    }
  }
}

const accountingService = new AccountingService();

export default accountingService;
